<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-bell card-file-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">

      <div ref="displayStatHtml"></div>

      <div class="card-data mb-2">

        <div class="typing_delay clearfix mb-2 p-1 pl-3 pr-3" v-if="node.data.IsTypingOnDisplayChecked && node.data.otnPostbackIdValue && node.data.otnPostbackIdText">
          <p class="typing_display float-left mb-0 p-0">
            <img :src="baseUrl + 'assets/pre-loader/typing_on.gif'" height="9px" width="20px"> {{ typing_display }}
          </p>
          <p class="delay_time float-right mb-0" v-if="node.data.delayReplyFor">
            {{ node.data.delayReplyFor }} {{ sec }}
          </p>
        </div>
        <p class="text-center mb-2 postback_title" v-if="node.data.otnTitleValue">
          {{node.data.otnTitleValue}}
        </p>

        <div class="list-group mt-2">
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.otnPostbackIdValue && node.data.otnPostbackIdText">         
            <small class="text-muted">{{ button_html_label_postback_id }}</small>
            <p class="mb-0"> {{ node.data.otnPostbackIdText }}</p>
          </span>
        </div>

      </div>

      <div class="card-sockets">
        <div class="output text-right float-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
        <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{input.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { lang } from '../../assets/lang'
import { templateComponentMethods, updateNodeConnections } from '../../functions/utils'

export default {
  name: 'OtnTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    sec: lang.common_info_sec,
    baseUrl: window.xitFlowBuilderData.base_url,
    typing_display: lang.common_info_typing_display,
    button_html_label_postback_id: lang.button_html_label_postback_id,
  }),

  methods: {
    ...templateComponentMethods,
  },

  async mounted() {
    const result = await this.displayStat(this.$props.node)
    $(this.$refs.displayStatHtml).html(result)

    updateNodeConnections(this.$props.node)
  }
}
</script>

<style scoped>
.card-file-icon { font-size: 13px; }
.xit-fb-template.hasData { min-width: 250px !important; }
.otn_postback_title {
  margin-bottom: -8px;
  font-size: 20px;
  /*font-family: garamond;*/
  font-weight: 900;
}

.otn_postback_id { color:#8d8d8d;margin-bottom:5px;}
</style>